import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initializeKeepAlive } from '../utils/keep-alive';

/**
 * Componente que inicializa o sistema de keep-alive
 * Apenas no painel admin para manter o servidor ativo
 */
function KeepAliveInitializer() {
  const location = useLocation();
  
  useEffect(() => {
    // Inicializar keep-alive apenas no painel admin
    if (location.pathname.startsWith('/admin')) {
      console.log('🔄 Inicializando keep-alive no painel admin...');
      initializeKeepAlive().catch((error) => {
        console.error('❌ Erro ao inicializar keep-alive:', error);
      });
      
      // Cleanup quando o componente desmontar ou sair do admin
      return () => {
        // Não parar keep-alive ao sair do admin, pois pode estar em outra rota do admin
        // O keep-alive continuará ativo enquanto o app estiver rodando
      };
    }
  }, [location.pathname]);
  
  return null; // Componente não renderiza nada
}

export default KeepAliveInitializer;

